import { CheckCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";

import { FetchDataWrapper } from "@/modules/fetch-data-wrapper";
import { NotificationCardSwitcher } from "@/modules/notification/notification-card-switcher";

import { NotificationsListCardLoader } from "./notifications-list-card-loader";
import { useNotificationsList } from "./notifications-list.hook";

import "./notifications-list.style.less";

export const NotificationsList = () => {
  const { t } = useTranslation();
  const {
    notifications,
    error,
    isLoading,
    hasNextPage,
    onLoadMore,
    scrollableTargetId,
    isUnreadView,
  } = useNotificationsList();

  return (
    <div className="notifications-list" id={scrollableTargetId}>
      <FetchDataWrapper
        data={notifications}
        error={error}
        loading={isLoading}
        loader={<NotificationsListCardLoader />}
        emptyDescription={
          isUnreadView ? t("notification:upToDate") : t("notification:noData")
        }
      >
        <InfiniteScroll
          dataLength={notifications.length}
          hasMore={hasNextPage}
          next={onLoadMore}
          loader={<NotificationsListCardLoader />}
          endMessage={
            !isUnreadView && (
              <Typography className="notifications-list-no-more">
                {t("notification:upToDate")}
                <CheckCircleOutlined />
              </Typography>
            )
          }
          scrollableTarget={scrollableTargetId}
        >
          {notifications.map((notification) => (
            <NotificationCardSwitcher
              key={notification.id}
              notification={notification}
            />
          ))}
        </InfiniteScroll>
      </FetchDataWrapper>
    </div>
  );
};
